import React from "react";

export type ChipVariant = "success" | "warning" | "danger" | "info" | "neutral";

interface StatusChipProps {
  label: string;
  variant: ChipVariant;
}

const variantStyles: Record<ChipVariant, { bg: string; text: string }> = {
  success: { bg: "rgba(45, 138, 95, 0.1)", text: "rgb(var(--success))" },
  warning: { bg: "rgb(var(--color-gold-2) / 0.1)", text: "rgb(var(--warning))" },
  danger: { bg: "rgba(184, 56, 56, 0.1)", text: "rgb(var(--danger))" },
  info: { bg: "rgba(59, 110, 143, 0.1)", text: "rgb(var(--info))" },
  neutral: { bg: "rgb(var(--surface-3))", text: "rgb(var(--text-secondary))" },
};

export default function StatusChip({ label, variant }: StatusChipProps) {
  const styles = variantStyles[variant];

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        fontSize: "10px",
        fontWeight: 500,
        fontFamily: "Poppins, sans-serif",
        paddingLeft: "10px",
        paddingRight: "10px",
        paddingTop: "3px",
        paddingBottom: "3px",
        borderRadius: "999px",
        backgroundColor: styles.bg,
        color: styles.text,
        whiteSpace: "nowrap",
        letterSpacing: "0.02em",
      }}
    >
      {label}
    </span>
  );
}
